var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Flex, Image } from 'pcln-design-system';
var LOGO_HEIGHTS = {
    sm: '40px',
    lg: '56px',
};
var FIXED_LOGO_HEIGHTS = {
    sm: '80px',
    md: '128px',
    lg: '160px',
};
var FIXED_LOGO_WIDTHS = {
    sm: '200px',
    md: '200px',
    lg: '200px',
};
var Logo = function (_a) {
    var fixedLogoSize = _a.fixedLogoSize, isCondensed = _a.isCondensed, logoImageUrl = _a.logoImageUrl, _b = _a.showLogoImageBackground, showLogoImageBackground = _b === void 0 ? true : _b, _c = _a.lazyLoad, lazyLoad = _c === void 0 ? true : _c, props = __rest(_a, ["fixedLogoSize", "isCondensed", "logoImageUrl", "showLogoImageBackground", "lazyLoad"]);
    var logoHeight = isCondensed ? LOGO_HEIGHTS.sm : [LOGO_HEIGHTS.sm, null, LOGO_HEIGHTS.lg];
    return (React.createElement(Flex, __assign({ alignItems: 'center', bg: showLogoImageBackground ? 'rgba(0, 0, 0, 0.7)' : 'transparent', borderRadius: 'lg', justifyContent: 'center' }, props),
        React.createElement(Image, { height: fixedLogoSize ? FIXED_LOGO_HEIGHTS[fixedLogoSize] : logoHeight, loading: lazyLoad ? 'lazy' : 'eager', objectFit: 'contain', src: logoImageUrl, width: fixedLogoSize ? FIXED_LOGO_WIDTHS[fixedLogoSize] : undefined })));
};
export default Logo;
//# sourceMappingURL=Logo.js.map